import { useTranslation } from "react-i18next"
import type { CourseStatus } from "../types"

interface CourseStatusBadgeProps {
  status: CourseStatus
  size?: "sm" | "md"
}

const STATUS_CONFIG: Record<CourseStatus, { labelKey: string; className: string }> = {
  draft: {
    labelKey: "courses.status.draft",
    className: "bg-surface-100 text-neutral-600",
  },
  active: {
    labelKey: "courses.status.active",
    className: "bg-mindeia-success-light text-mindeia-success",
  },
  archived: {
    labelKey: "courses.status.archived",
    className: "bg-neutral-800 text-white",
  },
}

export function CourseStatusBadge({ status, size = "md" }: CourseStatusBadgeProps) {
  const { t } = useTranslation()
  const config = STATUS_CONFIG[status]
  const sizeClass = size === "sm" ? "px-2 py-0.5 text-xs" : "px-2.5 py-1 text-xs"

  return (
    <span
      className={[
        "inline-flex items-center rounded-full font-medium",
        sizeClass,
        config.className,
      ].join(" ")}
    >
      {t(config.labelKey)}
    </span>
  )
}
